import type { ProtocolEdgeType } from '@ipfabric/utils';
import { tablesInProtocols } from '../protocolTables';

/**
 * Grouped edges and valid protocols can be opened.
 * We assume that valid protocol has defined table filters.
 */
export const canOpenDeviceEdgeEntity = (protocol?: ProtocolEdgeType): boolean =>
  protocol === undefined ||
  (protocol !== undefined && tablesInProtocols[protocol] !== undefined);
